import $ from 'jquery';
window.$ = window.jQuery = $;

import bootstrap from 'bootstrap/dist/js/bootstrap.min';
window.bootstrap = bootstrap;

import moment from 'moment';
window.moment = moment;

import 'jquery-validation';